module.exports = __webpack_public_path__ + "static/media/reference-slider-10.b1628244.jpg";